import { useState } from "react";
import { register } from "../../../api";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../hooks/useUser";
import { RegisterController } from "../types";
import { toast } from "sonner";
import { ClientStateAtom } from "@/store/ClientStateAtom";
import { useSetAtom } from "jotai";

export const useRegisterController = (): RegisterController => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [clientName, setClientName] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );
  const [formEmailError, setFormEmailError] = useState<string | undefined>(
    undefined
  );
  const [formPasswordError, setFormPasswordError] = useState<
    string | undefined
  >(undefined);
  const navigate = useNavigate();
  const user = useUser();
  const setClientData = useSetAtom(ClientStateAtom);

  const performRegister = async () => {
    setLoading(true);
    setFormEmailError(undefined);
    setFormPasswordError(undefined);
    user.setLoading(true);

    try {
      const res = await register(
        email,
        password,
        firstName,
        lastName,
        clientName
      );

      if (res.success) {


          setClientData({
            clientId: res.user.clientId,
            clientKey: res.user.clientKey,
          });
    
        localStorage.setItem("clientId", res.user.clientId);
        localStorage.setItem("clientKey", res.user.clientKey);
    

        user.setLoginSettings(email, "default", res.token);
        localStorage.setItem("token", res.token);
        navigate("/app/dashboard");
      } else {
        if (res.errors) {
          res.errors.forEach((e: any) => {
            if (e.path === "email") {
              setFormEmailError(e.msg);
              toast.error("Error", { description: e.msg });
            }
            if (e.path === "password") {
              setFormPasswordError(e.msg);
              toast.error("Error", { description: e.msg });
            }
          });
        } else {
          setErrorMessage(res.message);
          toast.error("Error", { description: res.message });
        }
        user.logUserOut();
      }
    } catch (error: any) {
      console.error("Registration failed:", error);
      toast.error("Error", {
        description: "Failed to register. Please try again.",
      });
      user.logUserOut();
    } finally {
      setLoading(false);
      user.setLoading(false);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    firstName,
    lastName,
    clientName,
    setClientName,
    setFirstName,
    setLastName,
    register: performRegister,
    loading,
    formEmailError,
    formPasswordError,
    errorMessage,
  };
};
